import { getSdk } from '../../__generated__/beehive'
import { BACKEND_ENDPOINT } from '../webpackConstants'

interface RequesterOptions {
    endpoint: string
}

export class AuthenticationError extends Error {
    constructor(message: string) {
        super(message)

        // Set the prototype explicitly.
        // See https://github.com/microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
        Object.setPrototypeOf(this, AuthenticationError.prototype)
    }
}

function createRequester(options: RequesterOptions) {
    return async function requester(query: string, variables: unknown) {
        const response = await fetch(options.endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query,
                variables,
            }),
        })

        if (response.status === 401) {
            throw new AuthenticationError(
                'Unauthorized: Your token is invalid.'
            )
        }

        const body = await response.json()

        return body.data
    }
}

export function getBeehiveSdk() {
    return getSdk(
        createRequester({
            endpoint: BACKEND_ENDPOINT,
        })
    )
}
